import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';

const _serviceDependencies = ['$scope', '$window', 'UserRestService', '$state'];
let _$scope;
let _$window;
let _UserRestService;
let _user;
let _$state;
let lang;
let currentRoute;

class ChangeLang {

    constructor($scope, $window, UserRestService, $state) {

        _$scope = $scope;
        _$window = $window;
        _$state = $state;
        _$scope.languages = [];
        _$scope.changeLanguage = this.changeLanguage;
        _$scope.currentLanguage = _$window.location.pathname;
        _user = MeRepository.getMyUser();
        _UserRestService = UserRestService;

        angular.forEach(CWCONFIG.languages, (value, key) => {

            _$scope.languages.push({ code: key, name: value });

        });

    }
    changeLanguage(inputLanguage) {

        const payload = {
            data: {
                id: _user.id,
                attributes: {
                    language: inputLanguage,
                },
                type: _user.type,
            },
        };

        _UserRestService.update(_user.id, payload).then(() => {

            lang = inputLanguage;

            if (_$state.params.resourceId === 'all') {

                // get the first position from split
                [currentRoute] = _$window.location.pathname.split('all');
                currentRoute = currentRoute.slice(0, -1);

            } else {

                // get the first position from split
                [currentRoute] = _$window.location.pathname.split('ltb').slice(0, -1);
                currentRoute = currentRoute.slice(0, -1);

            }

            _$window.location.pathname = currentRoute.replace(CWCONFIG.language, lang);

        }).catch(() => {

            Alert.error('cw.notification.system.error');

        });


    }

}

_serviceDependencies.push(ChangeLang);

angular.module('controllers')
    .controller('LanguageSwitcherCtrl', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/language-switcher/language-switcher.js